import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { beavertonConfig } from "./data";

export default function BeavertonPage() {
  return <OregonCityPageTemplate config={beavertonConfig} />;
}